import { Link } from "react-router-dom";
import { MapPin, ShoppingBasket, Package, LogOut } from "lucide-react";
import { useStore } from "@/context/StoreContext";

export const Header = () => {
  const { area, setAreaOpen, count, setCartOpen, customer, logout } = useStore();
  return (
    <header className="sticky top-0 z-50 bg-[#F9F8F4] border-b border-stone-200/70" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 h-16 flex items-center gap-3">
        <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="brand-link">
          <img src="/images/logo.jpg" alt="Mukti Fresh Vegetable" className="w-11 h-11 rounded-full object-cover" data-testid="brand-logo" />
          <span className="hidden sm:flex flex-col leading-none">
            <span className="font-display text-2xl font-semibold text-primary">Mukti</span>
            <span className="text-[10px] tracking-[0.2em] uppercase text-secondary font-bold">Fresh Vegetable</span>
          </span>
        </Link>
        <button onClick={() => setAreaOpen(true)} data-testid="pincode-selector"
          className="ml-auto sm:ml-6 flex items-center gap-2 rounded-full bg-white border border-stone-200 px-3 py-1.5 text-sm hover:border-primary/40 transition-colors">
          <MapPin className="w-4 h-4 text-accent" strokeWidth={1.5} />
          <span className="font-semibold text-primary" data-testid="current-pincode">{area ? area.pincode : "Set pincode"}</span>
          {area && <span className="hidden md:inline text-stone-500 max-w-[160px] truncate">{area.name}</span>}
        </button>
        <nav className="flex items-center gap-1 sm:ml-auto">
          {customer && (
            <>
              <Link to="/orders" data-testid="my-orders-link" className="hidden sm:flex items-center gap-1.5 px-3 py-2 rounded-full text-sm font-medium text-primary hover:bg-white transition-colors">
                <Package className="w-4 h-4" strokeWidth={1.5} /> Orders
              </Link>
              <button onClick={logout} data-testid="customer-logout-btn" className="hidden sm:flex p-2 rounded-full hover:bg-white text-stone-500 transition-colors" title="Sign out">
                <LogOut className="w-4 h-4" strokeWidth={1.5} />
              </button>
            </>
          )}
          {customer && (
            <Link to="/orders" data-testid="my-orders-link-mobile" className="sm:hidden p-2 rounded-full text-primary"><Package className="w-5 h-5" strokeWidth={1.5} /></Link>
          )}
          <button onClick={() => setCartOpen(true)} data-testid="open-cart-btn"
            className="relative flex items-center gap-2 rounded-full bg-primary text-white px-4 py-2 text-sm font-semibold active:scale-95 transition-transform">
            <ShoppingBasket className="w-4 h-4" strokeWidth={1.5} />
            <span className="hidden sm:inline">Basket</span>
            <span data-testid="cart-count" className="min-w-[20px] h-5 px-1 rounded-full bg-accent text-[11px] flex items-center justify-center">{count}</span>
          </button>
        </nav>
      </div>
    </header>
  );
};
